exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".note-item-actions[data-v-05c60b56]{display:none}.child-note-item:hover .note-item-actions[data-v-05c60b56],.note-item:hover .note-item-actions[data-v-05c60b56]{display:flex}", ""]);

// exports
